import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../context/AdminAuthContext";
import { ShieldCheck, SpinnerGap } from "@phosphor-icons/react";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { formatErr } from "../lib/api";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/admin", { replace: true });
    } catch (e2) {
      setErr(e2?.message === "Этот аккаунт не имеет прав администратора" ? e2.message : formatErr(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0E17] px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-11 h-11 rounded-xl bg-[#E3B341]/15 ring-1 ring-inset ring-[#E3B341]/30 flex items-center justify-center">
            <ShieldCheck size={22} weight="fill" className="text-[#E3B341]" />
          </div>
          <div>
            <p className="text-[10px] tracking-[0.2em] text-[#6B7280] uppercase">Arena · Admin</p>
            <h1 className="text-xl font-semibold text-white">Панель управления</h1>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-[10px] tracking-[0.18em] text-[#6B7280] uppercase">Email</label>
            <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required
              placeholder="admin@arenatb.com"
              className="mt-1 h-11 bg-[#111827] border-[#1F2937] text-white rounded-lg" data-testid="admin-email-input" />
          </div>
          <div>
            <label className="text-[10px] tracking-[0.18em] text-[#6B7280] uppercase">Пароль</label>
            <Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required
              placeholder="••••••••"
              className="mt-1 h-11 bg-[#111827] border-[#1F2937] text-white rounded-lg" data-testid="admin-password-input" />
          </div>
          {err && <p className="text-sm text-[#F6465D]" data-testid="admin-login-error">{err}</p>}
          <Button type="submit" disabled={loading}
            className="w-full h-11 bg-[#E3B341] hover:bg-[#d3a52f] text-[#0A0E17] font-semibold rounded-lg"
            data-testid="admin-login-submit">
            {loading ? <SpinnerGap size={18} className="animate-spin" /> : "Войти"}
          </Button>
        </form>
      </div>
    </div>
  );
}
